import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductContents } from './components/ProductContents';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { FAQSection } from './components/FAQSection';
import { PriceBlock } from './components/PriceBlock';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-creme font-sans text-dark-coffee selection:bg-warm-accent/20" data-id="element-0">
      <div className="w-full bg-dark-coffee py-2 text-center z-[60] relative" data-id="element-1">
        <p className="text-creme text-xs sm:text-sm font-medium tracking-wide" data-id="element-2">
          ⚠️ Si estás leyendo esto, no es casualidad.
        </p>
      </div>

      <CountdownTimer data-id="element-3" />
      <main className="relative overflow-hidden" data-id="element-4">
        <HeroSection data-id="element-5" />
        <PainSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <ProductContents data-id="element-8" />
        <WhoIsThisFor data-id="element-9" />
        <FAQSection data-id="element-10" />
        <PriceBlock data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingCTA data-id="element-13" />
    </div>;
}